<template>
  <v-container fluid class="pa-0">
    <template v-for="(intention, i) in data">
      <intent-card
        v-if="!intention.childrens"
        class="border pr-5"
        :key="`intention-${parent}-children-${i}`"
        :intention="intention"
        :parent="`${parent}[${i}]`"
        :is-children="isChildren"
        @edit="$emit('edit-intention', $event)"/>
      <v-expansion-panel
        v-else
        class="elevation-0"
        :key="`intention-${parent}-children-${i}`"
        expand>
        <v-expansion-panel-content :value="true">
          <intent-card
            slot="header"
            :intention="intention"
            :parent="`${parent}[${i}]`"
            :is-children="isChildren"
            @edit="$emit('edit-intention', $event)"
            class="expansion-panel elevation-0"/>
          <flow-tree
            :data="intention.childrens"
            :parent="`${parent}[${i}]`"
            @edit-intention="$emit('edit-intention', $event)"
            :is-children="true"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-container>
</template>

<script>
import IntentCard from '@/components/bot_v4/Detail/IntentCard';

export default {
  name: 'FlowTree',
  props: {
    parent: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      required: true,
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IntentCard,
  },
};
</script>

<style scoped>
.expansion-panel__container /deep/ > .expansion-panel__header {
  padding: 0 !important;
  padding-right: 24px !important;
}
.border, .expansion-panel__container /deep/ > .expansion-panel__header {
  border-bottom: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// src/components/bot_v4/Detail/FlowTree.vue